import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {Button, Form, Spinner} from "react-bootstrap";

const UpdateSDS = () => {
    let navigate = useNavigate();

    const [sds_name, set_sds_name] = useState('N/A')
    const [manufacturer, set_manufacturer] = useState('N/A')
    const [revision_date, set_revision_date] = useState('N/A')
    const [sds_document, set_sds_document] = useState()
    const [new_sds_document, set_new_sds_document] = useState(null)

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const {id} = useParams();

    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    const loadSDS = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/sds/${id}/`, {
            // const {data} = await axios.get(`http://127.0.0.1:8000/api/sds/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });
        set_sds_name(data.sds_name)
        set_manufacturer(data.manufacturer)
        set_revision_date(data.revision_date)
        set_sds_document(data.sds_document)
        // console.log(typeof data.sds_document)
    }

    useEffect(() => {
        loadSDS();
    }, [])

    const updateSDS = async () => {
        setDoneSubmitting(true)
        let formField = new FormData()

        formField.append('sds_name', sds_name)
        formField.append('manufacturer', manufacturer)
        formField.append('revision_date', revision_date)
        if (new_sds_document !== null){
            formField.append('sds_document', new_sds_document)
        }

        await axios({
            method: 'PUT',
            url: `https://homesafetysolutions.pythonanywhere.com/api/sds/update/${id}/`,
            // url: `http://127.0.0.1:8000/api/sds/update/${id}/`,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            data: formField,
        }).then(() => {
            navigate('/sds')
        })
        setDoneSubmitting(false)
    }


    return (
        <div className={"banner_heading"}>

            <h1>Update SDS:</h1>
            <Form>
                <Form.Group controlId={'sds_name'}>
                    <Form.Label>SDS Name</Form.Label>
                    <Form.Control
                        // aria-required={true}
                        type={'text'}
                        name={'sds_name'}
                        value={sds_name}
                        onChange={(e) => set_sds_name(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId={'manufacturer'}>
                    <Form.Label>Manufacturer</Form.Label>
                    <Form.Control
                        type={'text'}
                        name={'manufacturer'}
                        value={manufacturer}
                        onChange={(e) => set_manufacturer(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId={'revision_date'}>
                    <Form.Label>Revision Date:</Form.Label>
                    <Form.Control
                        type={'date'}
                        placeholder={"Proposal Approved Date"}
                        value={revision_date}
                        onChange={(e) => set_revision_date(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId={'new_sds_document'}>
                    <Form.Label>SDS Document:</Form.Label>
                    {/*{*/}
                    {/*    sds_document?(<p>Link to the <a href={`http://127.0.0.1:8000${sds_document}`}> {sds_name} SDS PDF</a></p>):("No SDS Attached.")*/}
                    {/*}*/}
                    <Form.Control
                        type={'file'}
                        // value={sds_document}
                        onChange={(e) => set_new_sds_document(e.target.files[0])}
                    />
                </Form.Group>
                <br/>
                {
                    doneSubmitting
                        ?
                        (
                            <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                        )
                        :
                        (
                            <Button className={'btn btn-success'} onClick={updateSDS}>Update SDS</Button>
                        )
                }
            </Form>


        </div>
    );
};

export default UpdateSDS;


// import React from 'react';
//
// const UpdateSDS = (props) => (
//
// );
//
// export default UpdateSDS;